import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Client-side validation
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      setLoading(false);
      return;
    }

    try {
      // Note: For development, consider using a proxy to avoid CORS issues.
      // Add to package.json: "proxy": "https://dropquote.co.za/backend"
      // Then use: fetch('/login.php', { ... })
      const response = await fetch('https://dropquote.co.za/backend/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      console.log('Backend response:', data); // Debug log

      if (!response.ok) {
        throw new Error(data.message || 'Authentication failed');
      }

      if (data.isAuthenticated) {
        localStorage.setItem('isAuthenticated', 'true');
        navigate('/admin');
      } else {
        throw new Error(data.message || 'Authentication failed');
      }
    } catch (err) {
      setError(
        err.message.includes('Failed to fetch')
          ? 'Network error: Please check your connection or server status'
          : err.message
      );
      setUsername('');
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2>Admin Login</h2>
      <form onSubmit={handleLogin}>
        <div>
          <label htmlFor="username" className="text-dark">
            Username
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={loading}
            placeholder="e.g., sbu@gmail.com"
          />
        </div>
        <div>
          <label htmlFor="password" className="text-dark">
            Password
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
            placeholder="Enter password"
          />
        </div>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <button type="submit" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2 text-danger" role="status" aria-hidden="true"></span>
              Logging in...
            </>
          ) : (
            'Login'
          )}
        </button>
      </form>
    </div>
  );
};

export default Login;